import {uploadFileAPI} from "./KB/Files";
import {getRandomBetween, RAW_FILES_URL} from "../utils";

export const OFFICIAL_API_URL = 'https://api.openkbs.com';

async function blobUrlToFile(blobUrl, filename) {
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    return new File([blob], filename, { type: blob.type });
}

export function getKBFileURL(filename, kbId) {
    return `${RAW_FILES_URL}/files/${kbId}/${filename}`
}

export function getFileExtensionFromMimeType(mimeType) {
    // A map of common MIME types to file extensions
    const mimeToExtensionMap = {
        'audio/aac': 'aac',
        'audio/midi': 'midi',
        'audio/x-midi': 'midi',
        'audio/mpeg': 'mp3',
        'audio/ogg': 'oga',
        'audio/opus': 'opus',
        'audio/wav': 'wav',
        'audio/webm': 'webm',
        'audio/3gpp': '3gp',
        'audio/3gpp2': '3g2',
    };

    // Extract the base MIME type (e.g., "audio/webm" from "audio/webm;codecs=opus")
    const baseMimeType = mimeType.split(';')[0].trim();

    // Look up the file extension from the map
    const extension = mimeToExtensionMap[baseMimeType];

    // Fallback mechanism: if the extension is not found in the map, attempt to guess the extension
    if (!extension) {
        // Guess the extension based on the MIME type (e.g., "audio/webm" -> "webm")
        const guessedExtension = baseMimeType.split('/')[1];
        if (guessedExtension) {
            return guessedExtension;
        }
        // If all else fails, return an empty string or a default extension
        return '';
    }

    return extension;
}

export const saveBlobFileToS3 = async ({ blobURL, filename}) => {
    const file = await blobUrlToFile(blobURL, filename);
    return await uploadFileAPI(file, 'files');
}

export function getRequestId() {
    return getRandomBetween(1, 10**12)
}

// Example usage with the data returned from the Lambda function
export const saveImageToS3 = async ({imageSrc, filename}) => {
    // Assuming data.imageSrc is something like "data:image/png;base64,iVBORw0KGgo..."
    const base64Data = imageSrc.split(',')[1]; // Split to get the base64 part
    const contentType = imageSrc.split(',')[0].split(':')[1].split(';')[0]; // Split to get the content type (e.g., image/png)

    const blobUrl = base64ToBlobUrl(base64Data, contentType);

    await saveBlobFileToS3({ blobURL: blobUrl, filename});
};

// Function to convert base64 to Blob
const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mimeType });
};

// Function to convert base64 image data to a blob URL
const base64ToBlobUrl = (base64Data, contentType) => {
    const blob = base64ToBlob(base64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
};
